import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import MetaData from "../../components/MetaData";
import Loader from "../../components/Loader";
import * as orderActions from "./orderConfirmation.reducer";
import * as cartActions from "../Cart/cart.reducer";
import _ from "lodash";
import * as orderUtils from "./order.utils";
import {
  Grid,
  Divider,
  Button,
  Segment,
  Label,
  Modal,
  Icon,
  Form,
  Message,
  Confirm,
} from "semantic-ui-react";
import CartProducts from "../../components/CartProducts";
import TotalPrice from "../../components/TotalPrice";
import "./orderConfirmation.css";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import OrderDetails from "../../components/OrderHistoryList/OrderDetails";
import { getErrorMessage } from "../../utils/error.utils";
import ErrorMessageBox from "../../components/ShowErrorMessage";
import UserRoleCheck from "../../components/UserRoleCheck";
import { DEFAULT_TAX } from "../../constants/appConstants";
import { getAccountTax } from "../../containers/OrderConfirmation/order.utils";
import { apiGetUserCurrentStockLocation } from "../Cart/cart.api";
import { refreshToken } from "../Auth/auth.api";
import * as authActions from "../Auth/auth.reducer";
import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import deliveryIcon from "../../assets/images/icons/delivery-icon.png";
import storeIcon from "../../assets/images/icons/store-icon.png";
import { apiGetAddresses } from "../Profile/DeliveryAddress/deliveryAddress.api";
import ManageAddress from "../ManageAddress";

const SwitchContainer = styled(Box)({
  width: 110,
  height: 40,
  backgroundColor: "#ffffff",
  borderRadius: 999,
  boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 8px",
  position: "relative",
  cursor: "pointer",
  overflow: "hidden",
});

const IconThumb = styled(Box)(({ theme, checked }) => ({
  width: 28,
  height: 28,
  borderRadius: "50%",
  backgroundColor: checked ? "#63d237" : "#42A5F6",
  position: "absolute",
  top: "6px",
  left: checked ? "calc(100% - 34px)" : "6px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "left 0.3s ease-in-out, background-color 0.3s ease-in-out",
}));

class OrderConfirmationComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialLoad: true,
      modalOpen: false,
      orderPlaced: false,
      isError: true,
      errorMessage: "",
      isLoading: false,
      iAgree: false,
      pickUpFlag: false,
      pickUpModalOpen: false,
      pickupData: null,
      pickAddressObject: null,
      isDelivery: true,
      openManageAddress: false,
      deliveryAddresses: [],
      pickUpAddresses: [],
      selectedAddress: {},
      currentLocation: {
        lat: null,
        lng: null,
      },
    };
    this.debounceTimer = null;
  }

  async componentDidMount() {
    this.debounceTimer = setTimeout(async () => {
      await this.props.actionGetAccountDetails();
      await this.props.actionSetCart();
      this.setState({ initialLoad: false });

      // Get Location
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.setState({
              currentLocation: {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              },
            });
          },
          (error) => {
            // Set coordinates to zero if navigator fails to get user's coordinates
            this.setState({
              currentLocation: {
                lat: 0,
                lng: 0,
              },
            });
            // Identify what caused the navigator error
            switch (error.code) {
              case error.PERMISSION_DENIED:
                console.log("Location access denied by user");
                break;
              case error.POSITION_UNAVAILABLE:
                console.log("Location information is unavailable");
                break;
              case error.TIMEOUT:
                console.log("Location request timed out");
                break;
              default:
                console.log("An unknown error occurred");
                break;
            }
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    }, 500);

    this.props.actionSetCustomerOrderNumber("");
    this.props.actionSetCustomNotes("");
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      this.state.currentLocation !== prevState.currentLocation &&
      this.state.currentLocation.lat !== null &&
      this.state.currentLocation.lng !== null
    ) {
      this.getAddresses();
    }

    if (this.state.isDelivery !== prevState.isDelivery) {
      const { deliveryAddresses, pickUpAddresses, isDelivery } = this.state;
      let address = {};
      if (isDelivery) {
        address = deliveryAddresses.find((item) => item.isSelected === true);
        if (!address)
          address = deliveryAddresses.find((item) => item.isDefault === true);
      } else {
        address = pickUpAddresses.find((item) => item.isSelected === true);
        if (!address)
          address = pickUpAddresses.find((item) => item.isDefault === true);
      }
      this.setState({ selectedAddress: address });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.debounceTimer);
    this.props.actionClearResponse();
  }

  handleToggle = () => {
    this.setState((prevState) => ({ isDelivery: !prevState.isDelivery }));
  };

  calculateTax = () => {
    let tax = DEFAULT_TAX;
    if (this.props.accountInfo) {
      const { overrideGSTRate } = this.props.accountInfo;
      tax = getAccountTax(overrideGSTRate);
    }
    return tax;
  };

  getAddresses = async () => {
    this.setState({ isLoading: true });
    const result = await apiGetAddresses(this.state.currentLocation);
    if (result) {
      const { isDelivery } = this.state;
      let address = {};
      if (isDelivery) {
        address = result.deliveryAddresses.find(
          (item) => item.isDefault === true
        );
      } else {
        address = result.pickUpAddresses.find(
          (item) => item.isDefault === true
        );
      }
      this.setState({
        selectedAddress: address,
        deliveryAddresses: result.deliveryAddresses,
        pickUpAddresses: result.pickUpAddresses,
        isLoading: false,
      });
    }
  };

  goToCart = () => {
    this.props.history.push("/cart");
  };

  getOrderDetails = () => {
    return orderUtils.getOrderDetails(this.props.cart);
  };

  payWithBoa = async () => {
    const {
      accountInfo,
      customerOrderNumber,
      user,
      cart,
      customNotes,
      actionPlaceOrderCredit,
      status,
      statusText,
    } = this.props;
    const { selectedAddress, isDelivery } = this.state;

    this.setState({
      modalOpen: false,
      errorMessage: "",
      isError: true,
      pickUpModalOpen: false,
    });

    if (_.isEmpty(customerOrderNumber)) {
      this.setState({
        isError: false,
        errorMessage: "Please add a Purchase Order number",
        modalOpen: false,
      });
      window.scrollTo(0, 0);
      return;
    }

    if (_.isEmpty(selectedAddress)) {
      this.setState({
        isError: false,
        errorMessage: `Please add ${
          isDelivery ? "delivery" : "pickup"
        } address`,
        modalOpen: false,
      });
      window.scrollTo(0, 0);
      return;
    }

    this.setState({ isLoading: true });
    let orderData = {
      partnerInvoiceId: user.id,
      partnerShippingId: selectedAddress.id,
      clientOrderRef: customerOrderNumber,
      probDeliveryNotes: customNotes,
      boahubLocationId: Number(localStorage.getItem("boahubLocationId")),
      selectedCartItems: cart,
    };

    await actionPlaceOrderCredit(orderData);
    // await refreshToken();
    // await this.getCurrentStockLocation();
    this.setState({ isLoading: false });

    if (this.props.status === 200) {
      this.showOrderSuccessMessage();
    } else if (this.props.status === 424) {
      this.setState({ modalOpen: false });
      showErrorToast("Something went wrong, please try again");
    } else {
      this.setState({ modalOpen: false });
      window.scrollTo(0, 0);
      this.setState({ isError: false, errorMessage: statusText });
    }
  };

  getCurrentStockLocation = async () => {
    const currentStockLocation = await apiGetUserCurrentStockLocation();
    if (currentStockLocation?.id) {
      localStorage.setItem(
        "boahubLocationId",
        currentStockLocation.id.toString()
      );
      localStorage.setItem(
        "stockLocationName",
        currentStockLocation.stockLocationName
      );
    }
  };

  showOrderErrorMessage = async (status) => {
    window.scrollTo(0, 0);
    const message = await getErrorMessage(status);
    this.setState({ isError: false, errorMessage: message });
  };

  showOrderSuccessMessage = () => {
    window.scrollTo(1, 1);
    showSuccessToast(
      <div>
        <i className="check icon" /> Order Placed Successfully
      </div>
    );
    this.setState({ orderPlaced: true });
  };

  PayWithPaymentExpress = async () => {
    const {
      accountInfo,
      customerOrderNumber,
      overallDiscount,
      pxPayInitiateResponse,
    } = this.props;
    const { selectedAddress, pickUpFlag, pickAddressObject, isDelivery } =
      this.state;

    this.setState({ modalOpen: false, errorMessage: "", isError: true });

    if (accountInfo?.needOrderNumber && _.isEmpty(customerOrderNumber)) {
      this.setState({
        isError: false,
        errorMessage: "Please add PO number",
      });
      window.scrollTo(0, 0);
      return;
    }

    if (_.isEmpty(selectedAddress)) {
      this.setState({
        isError: false,
        errorMessage: `Please add ${
          isDelivery ? "delivery" : "pickup"
        } address`,
      });
      window.scrollTo(0, 0);
      return;
    }

    this.setState({ isLoading: true });
    let currentDeliveryAddress = selectedAddress;
    if (pickUpFlag && pickAddressObject) {
      currentDeliveryAddress = pickAddressObject;
    }
    const { status: pxPayStatus = 200, data: pxPayData } =
      pxPayInitiateResponse;
    this.setState({ isLoading: false });

    if (pxPayStatus === 200 && pxPayData?.pxPayUrl) {
      document.location.href = pxPayData.pxPayUrl;
    } else if (pxPayStatus === 424) {
      showErrorToast("Something went wrong, please try again");
    } else if (pxPayData?.code) {
      this.showOrderErrorMessage(pxPayData.code);
    }
  };

  getCartCount = () => {
    let quantity = 0;
    _.forEach(this.props.cart, (item) => {
      quantity += Number(item.quantity);
    });
    return <span> Quantity {quantity}</span>;
  };

  computeSubtotal = () => {
    let subTotal = 0;
    _.forEach(this.props.cart, (item) => {
      if (item.buyPrice !== 0 && item.retailPrice !== 0) {
        subTotal += item.buyPrice * item.quantity;
      }
    });
    return subTotal;
  };

  editAddress = (e) => {
    e.preventDefault();
    // this.props.history.push("/profile/deliveryAddress");
  };

  modelOpenHandler = (e) => {
    e.preventDefault();
    this.setState({ modalOpen: true });
  };

  modelCloseHandler = () => {
    this.setState({ modalOpen: false, pickUpModalOpen: false });
  };

  modelPickupOpenHandler = (e) => {
    e.preventDefault();
    this.setState({ pickUpModalOpen: true });
  };

  modelPickUpCloseHandler = () => {
    this.setState({ pickUpModalOpen: false });
  };

  changeAddressHandler = (address) => {
    this.setState({ selectedAddress: address });
  };

  changePickupAddressHandler = (e, address) => {
    this.setState({ pickAddressObject: address, selectedAddress: address });
    showSuccessToast(
      <div>
        <Icon name="truck" /> {this.state.isDelivery ? "Delivery" : "Pickup"}{" "}
        Address changed
      </div>
    );
    this.modelPickUpCloseHandler();
  };

  onChangeReferenceHandler = (e) => {
    this.props.actionSetReference(e.target.value);
  };

  onChangeCustomNotesHandler = (e) => {
    this.props.actionSetCustomNotes(e.target.value);
  };

  onChangeCustomerOrderHandler = (e) => {
    this.props.actionSetCustomerOrderNumber(e.target.value);
  };

  goToOrderHistory = (e) => {
    e.preventDefault();
    // this.props.history.push("/orderHistory");
  };

  openDispatchDetails = (e) => {
    e.preventDefault();
    // this.setState({ openDispatchDetails: true });
  };

  closeDispatchDetails = (e) => {
    e.preventDefault();
    // this.setState({ openDispatchDetails: false });
  };

  orderSuccessSummary = (status) => {
    return (
      <div className="order-success-message">
        <Grid>
          <Grid.Column width={16}>
            {status === 200 ? (
              <div
                style={{
                  minHeight: "50vh",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "1rem",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    padding: "2rem",
                    borderRadius: "0.5rem",
                    textAlign: "center",
                    width: "100%",
                  }}
                >
                  <h1
                    style={{
                      fontSize: 32,
                      fontWeight: "bold",
                      marginBottom: "2rem",
                      fontFamily: "Inter, sans-serif",
                    }}
                  >
                    Thank you for your order!
                  </h1>
                  <p
                    style={{
                      color: "#4b5563",
                      marginBottom: "3rem",
                      fontFamily: "Inter, sans-serif",
                    }}
                  >
                    A confirmation email will be sent to you with complete order
                    details.
                  </p>
                  <a
                    style={{
                      cursor: "pointer",
                      color: "#4183C4",
                      fontWeight: "600",
                      fontSize: "1.125rem",
                      transitionProperty:
                        "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform" /* transition */,
                      transitionDuration: "300ms",
                      transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
                      textDecoration: "none",
                    }}
                    onClick={() => this.props.history.push("/")}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.color = "#1d4ed8")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.color = "#2563eb")
                    }
                  >
                    Back to home
                  </a>
                </div>
              </div>
            ) : (
              <Message negative icon>
                <Icon name="close" />
                <Message.Content>
                  <Message.Header>Sorry, Your order failed</Message.Header>
                  Your payment has been declined.
                </Message.Content>
              </Message>
            )}
          </Grid.Column>
          {/* <Grid.Column width={16}>
            <h3>
              <Icon name="sticky note outline" />
              Order Summary
            </h3>
            <Divider />
            <OrderDetails
              order={data}
              options={false}
              showPrice={true}
            />
          </Grid.Column> */}
        </Grid>
      </div>
    );
  };

  changedPickupAdd = () => {
    this.setState({ pickupData: this.state.pickUpAddresses });
    if (this.state.pickUpAddresses) {
      const primaryPickup = this.state.pickUpAddresses.find(
        (address) => address.isPrimary
      );
      if (primaryPickup) {
        this.setState({ pickAddressObject: primaryPickup });
      }
    }
  };

  checkBoxAddressHandler = async (e, data) => {
    if (data.checked) {
      this.setState({ iAgree: true, pickUpFlag: true });
      this.changedPickupAdd();
    } else {
      this.setState({ pickUpFlag: false });
      await this.props.actionSetDeliveryDetails();
    }
  };

  render() {
    const {
      cart,
      deliveryAddress,
      allAddresses,
      reference,
      customNotes,
      customerOrderNumber,
      accountInfo,
      user,
      pickUpAllAddresses,
    } = this.props;

    const {
      initialLoad,
      modalOpen,
      orderPlaced,
      isError,
      errorMessage,
      isLoading,
      isDelivery,
      openManageAddress,
      deliveryAddresses,
      pickUpAddresses,
      selectedAddress,
    } = this.state;

    const { customerType, userRole, account = {} } = user;
    const { showPrice = false } = account;
    const { status, overallDiscount } = this.props;
    const { stopCredit, needOrderNumber } = accountInfo;
    const { discount = 0 } = overallDiscount;
    let responseJSX = "";
    if (status === 200) {
      return this.orderSuccessSummary(status);
    }

    const cartJSX = (
      <div>
        <Modal
          onClose={() => this.setState({ openManageAddress: false })}
          onOpen={() => this.setState({ openManageAddress: true })}
          open={openManageAddress}
          className="manage-address-modal"
          closeOnDimmerClick={false}
        >
          <Modal.Content>
            <ManageAddress
              allAddress={isDelivery ? deliveryAddresses : pickUpAddresses}
              onCloseManageAddress={() =>
                this.setState({ openManageAddress: false })
              }
              changeAddressHandler={this.changeAddressHandler}
              isDelivery={isDelivery}
              getAddresses={this.getAddresses}
              hasSelect={true}
            />
          </Modal.Content>
        </Modal>
        {localStorage.getItem("boahubShowPurchasePrice") === "true" && (
          <Grid>
            <Grid.Column width={16}>
              <div className="total-price">
                <TotalPrice
                  cart={cart}
                  cartCount={this.getCartCount()}
                  account={accountInfo}
                  overallDiscount={discount}
                  subtotal={this.computeSubtotal()}
                />
              </div>
            </Grid.Column>
          </Grid>
        )}
        <Grid columns="equal">
          <Grid.Column computer={8} mobile={16}>
            {!isLoading ? (
              <h4>
                <Icon name="truck" /> {isDelivery ? "Delivery" : "Pickup"}{" "}
                address
                <a
                  onClick={() => this.setState({ openManageAddress: true })}
                  className="linkToPage"
                >
                  {`Manage ${isDelivery ? "Delivery" : "Pickup"} Address`}
                </a>
                {pickUpAddresses?.length > 0 && (
                  <div style={{ position: "absolute", right: 15, top: 7 }}>
                    <SwitchContainer onClick={this.handleToggle}>
                      <Typography
                        variant="body2"
                        sx={{
                          zIndex: 1,
                          marginLeft: isDelivery ? 0.7 : 5,
                          transition: "margin-left 0.3s ease-in-out",
                        }}
                      >
                        {isDelivery ? "Delivery" : "Pickup"}
                      </Typography>

                      <IconThumb checked={isDelivery}>
                        {isDelivery ? (
                          <Icon
                            name="truck"
                            style={{
                              color: "#fff",
                              fontSize: 15,
                              marginLeft: 3,
                              marginTop: -3,
                            }}
                          />
                        ) : (
                          <img
                            src={storeIcon}
                            style={{
                              height: "auto",
                              width: "80%",
                            }}
                          />
                        )}
                      </IconThumb>
                    </SwitchContainer>
                  </div>
                )}
              </h4>
            ) : (
              <h4>
                <Icon name="truck" /> Delivery address
              </h4>
            )}
            <Divider />
            {!_.isEmpty(selectedAddress) && (
              <Segment>
                <div>
                  {selectedAddress.isDefault && (
                    <Label
                      as="a"
                      style={{
                        backgroundColor: isDelivery ? "#66cc23" : "#42A5F6",
                        color: "#fff",
                      }}
                      ribbon
                    >
                      <p>Default address</p>
                    </Label>
                  )}
                  <div
                    style={{
                      paddingTop: selectedAddress.isDefault ? 20 : 0,
                      paddingBottom: 10,
                      fontWeight: "bolder",
                    }}
                  >
                    {selectedAddress.addressDetails?.name}
                  </div>
                  <div>
                    {selectedAddress.addressDetails?.street}{" "}
                    {selectedAddress.addressDetails?.street2}
                  </div>
                  <div>{selectedAddress.addressDetails?.suburb}</div>
                  {selectedAddress.addressDetails?.city + ", "}{" "}
                  {selectedAddress.addressDetails?.city !==
                  selectedAddress.addressDetails?.state
                    ? selectedAddress.addressDetails?.state
                    : selectedAddress.addressDetails?.city}
                  <div>{selectedAddress.addressDetails?.country}</div>
                  <div>{selectedAddress.addressDetails?.zipCode}</div>
                </div>
              </Segment>
            )}

            {_.isEmpty(selectedAddress) && !isLoading && (
              <Message
                icon="warning sign"
                header={`Please add ${
                  isDelivery ? "delivery" : "pickup"
                } address`}
                content={`You can't place order without ${
                  isDelivery ? "delivery" : "pickup"
                } address`}
              />
            )}

            {isLoading && <Loader text="" />}
          </Grid.Column>
          <Grid.Column computer={8} mobile={16}>
            <Form>
              <Form.Field>
                <h4>
                  <Icon name="pencil alternate" />
                  <label>
                    {" "}
                    PO number <span style={{ color: "red" }}>*</span>{" "}
                  </label>
                </h4>
                <input
                  type="text"
                  className="input-box customer-order-input"
                  maxLength={20}
                  name="customerOrderNumber"
                  onChange={this.onChangeCustomerOrderHandler}
                  value={customerOrderNumber}
                />
              </Form.Field>
              <Form.Field>
                <h4>
                  <Icon name="pencil alternate" /> <label>Notes</label>
                </h4>
                <textarea
                  maxLength={255}
                  rows="4"
                  className="input-box customer-order-input"
                  name="reference"
                  onChange={this.onChangeCustomNotesHandler}
                  value={customNotes}
                />
              </Form.Field>
            </Form>
          </Grid.Column>
        </Grid>
        <Grid columns={2}></Grid>
        <Grid centered columns={2}>
          <Grid.Column computer={8} mobile={16}></Grid.Column>
          <Grid.Column computer={8} mobile={16}>
            <UserRoleCheck userRole={userRole}>
              {!isLoading && (
                <React.Fragment>
                  <Button
                    onClick={() => {
                      this.setState({ modalOpen: true });
                    }}
                    style={{
                      color: "#fff",
                      backgroundColor: isDelivery ? "#66cc23" : "#42A5F6",
                    }}
                    fluid
                    size="large"
                  >
                    {`Confirm ${isDelivery ? "Delivery" : "Pickup"} Order`}
                  </Button>
                  <Confirm
                    style={{ marginTop: "-72px" }}
                    open={modalOpen}
                    content="Are you sure you want to submit your order?"
                    onCancel={() => {
                      this.setState({ modalOpen: false });
                    }}
                    onConfirm={this.payWithBoa}
                  />
                </React.Fragment>
              )}
              {isLoading && (
                <Button loading primary size="large" fluid>
                  Loading
                </Button>
              )}
            </UserRoleCheck>
          </Grid.Column>
        </Grid>{" "}
      </div>
    );

    const placeOrderJSX = (
      <div>
        {initialLoad && (
          <div
            style={{
              position: "absolute",
              top: 370,
              left: -30,
              width: "100%",
            }}
          >
            <Loader text="Loading order, please wait">
              Loading,please wait
            </Loader>
          </div>
        )}
        {!initialLoad && (
          <div>
            <Grid>
              <Grid.Column width={16}>
                <h3>
                  <Icon name="cart" />
                  Cart Items
                  <Button secondary floated="right" onClick={this.goToCart}>
                    Change Items
                  </Button>
                </h3>
              </Grid.Column>
              <Grid.Column width={16}>
                <CartProducts
                  cartProducts={cart}
                  options={false}
                  {...this.props}
                  showPrice={showPrice}
                  isOrderConfirmation
                />
              </Grid.Column>
            </Grid>
            {cartJSX}
          </div>
        )}
      </div>
    );

    return (
      <div className="confirm-order">
        <MetaData title="Order Confirmation" />
        <Grid.Row>
          <h3>
            <Icon name="check square outline" />
            Order Confirmation
          </h3>
          <Divider />
        </Grid.Row>
        <ErrorMessageBox isError={isError} message={errorMessage} />
        {status === 200 && orderPlaced && responseJSX}
        {!orderPlaced && placeOrderJSX}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cart: JSON.parse(localStorage.getItem("selectedCartItems")),
    deliveryAddress: state.orderConfirmation.deliveryAddress,
    reference: state.orderConfirmation.reference,
    customerOrderNumber: state.orderConfirmation.customerOrderNumber,
    customNotes: state.orderConfirmation.customNotes,
    response: state.orderConfirmation.response,
    user: state.auth.user,
    accountInfo: state.orderConfirmation.accountInfo,
    pxPayInitiateResponse: state.orderConfirmation.pxPayInitiateResponse,
    overallDiscount: state.orderConfirmation.overallDiscount,
    status: state.orderConfirmation.status,
    statusText: state.orderConfirmation.statusText,
  };
};

let reducer = { ...authActions, ...orderActions, ...cartActions };

const mapDispatchToProps = (dispatch) => bindActionCreators(reducer, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderConfirmationComponent);
